import React, { useCallback } from 'react';
import { batch, useDispatch } from 'react-redux';
import { Icon, Tappable } from '@vectord/components';
import classNames from 'classnames';

import {
  setAddSuperBatchModuleModalState,
  setSelectedSuperBatchModule,
} from 'features/moduleManagement';
import styles from './AddSuperBatchModuleButton.module.scss';

function AddSuperBatchModuleButton({ superBatchModule }) {
  const dispatch = useDispatch();

  const handleOnAdd = useCallback(() => {
    batch(() => {
      dispatch(setAddSuperBatchModuleModalState(true));
      dispatch(setSelectedSuperBatchModule({ ...superBatchModule }));
    });
  }, [dispatch, superBatchModule]);

  return (
    <Tappable
      className={classNames('btn btn-outlined btn-primary', styles.root)}
      onClick={handleOnAdd}
    >
      <Icon
        name="add"
        className="m-r-5"
      />{' '}
      Add Module Below
    </Tappable>
  );
}

export default AddSuperBatchModuleButton;
